import React, { useEffect, useState } from "react";
import { object, func } from "prop-types";
import get from "lodash/get";
import { useSelector } from "react-redux";

import "./group-and-plans.m.css";

export const GroupsAndPlansModal = ({ member, setActiveTab, setSelectedPlan, getSubscription, getSubscriptionForUser, setSelectedSubscriptionGroup, setIsCheckoutInitialized, hasActiveSubscription }) => {
  const [subscriptionsData, setSubscriptionsData] = useState([]);
  const [selectedSubscriptions, setSelectedSubscriptions] = useState({});

  const setCookie = (name, value, days) => {
    //const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; secure; samesite=strict`;
  };

  const { enable_subscription_feature, subscription_test_secret, subscription_page = {} } = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes"], {})
  );

  const title = subscription_page.title || "";
  const description = subscription_page.description || "";
  const footerText = subscription_page.footer || "";

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const secretKey = subscription_test_secret;
    const isDeiTest = queryParams.get('dei-test') === secretKey;
    const isGlobalEnabled = enable_subscription_feature === true;

    if (isGlobalEnabled || (isDeiTest && member)) {
      getSubscription().then((res) => {
        const sortedRes = res.sort((a, b) => {
          const priceA = parseFloat(a.subscription_plans?.[0]?.title?.replace(',', '.')) || 0;
          const priceB = parseFloat(b.subscription_plans?.[0]?.title?.replace(',', '.')) || 0;
          return priceA - priceB;
        });
        setSubscriptionsData(sortedRes);
      });
    }
  }, [member, enable_subscription_feature, subscription_test_secret]);
  useEffect(() => {
    const defaultSelectedOptions = {};
    subscriptionsData.forEach((group, id) => {
      const firstPlan = get(group, ["subscription_plans", "0"]);
      defaultSelectedOptions[group.name] = firstPlan;
    });
    setSelectedSubscriptions(defaultSelectedOptions);
  }, [subscriptionsData]);

  const handlePlanSelection = (groupName) => {
    const plan = selectedSubscriptions[groupName];
    if (!member) {
      setCookie("customSubscriptionRedirectURI", "/tilaus");
      localStorage.setItem("selectedPlanId", plan.id);
      localStorage.setItem("selectedPlanGroup", groupName);
    }
    setSelectedPlan({ plan });
    setSelectedSubscriptionGroup(groupName);
    console.log("Selected Group 1:", groupName);
    console.log("Selected Plan Object 1:", selectedSubscriptions[groupName]);
    if (member) {
      setActiveTab("checkout");
      setIsCheckoutInitialized(true);
    } else {
      setActiveTab("login");
    }
  };

  const style = `
  .video-container-wrapper {
    font-family: "Montserrat", sans-serif;
  }

  .channel-specific-radio-image {
    height: 50px;
    width: 50px;
    background: #a20d39;
    border-radius: 10px;
    padding:5px;
    margin: 5px;
  }

  .channel-specific-button {
    background:#a20d39;
    border:none;
    border-radius:10px;
    color: #fff;
    cursor: pointer;
    padding:10px;
    font-size:20px;
    margin: 5px;
  }

  .channel-specific-buttons-wrapper {
    display: flex;
    justify-content: center;
  }

  .top-banner-static-image {
    margin: 70px 0;
    text-align: center;
    position: relative;
    height: 600px;
  }
  .top-banner-static-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .top-banner-static-image .title h2 {font-family: "Montserrat", sans-serif;}
  .radio-container {
    color: #FFF;
    margin: 100px 20px 20px 20px;
  }

  .radio-container h2, .static-page-container h3 {
    margin-top: 2rem !important;
    color: #a20d39;
    font-family: "Montserrat", sans-serif;
  }

  .radio-container p {
    margin: 0.5rem 0 !important;
    font-size: 18px;
    font-family: "Montserrat", sans-serif;
  }

  .radio-container h3 {
    font-size: 22px !important;
    font-family: "Montserrat", sans-serif;
  }

  .radio-container a {
    color: #a20d39;
    font-weight: bold;
  }

  .custom-hero-container {
    position: relative;
    text-align: center;
    color: white;
    background-image: url("/assets/Helsinki-herojpg.jpg");
    background-size: cover;
    background-position: center;
    height: 500px;
    margin-bottom: 20px;
  }

  .custom-hero-heading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    font-size: 2em;
  }

  .location-img {
    text-align: center;
  }

  .mhz {
    text-align: right;
    color: #a20d39;
    margin: 10px;
  }

  .map-hero-container {
    margin-top: 20px;
    position: relative;
    text-align: center;
    color: white;
    background-image: url("/assets/Helsinki-web.jpg");
    background-size: cover;
    background-position: center;
    height: 600px;
  }

  .portrait-mobile-image {
    display: none;
  }

  .custom-hero-heading h1 {
    font-size: 50px !important;
    color: white;
    margin-bottom: 50px;
    font-family: "Montserrat", sans-serif;
  }
  .custom-hero-heading p {
    font-size: 22px  !important;
    font-family: "Montserrat", sans-serif;
  }

  .main-headline-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
 }

 .notFoundTitle {
    font-size: 39px !important;
    font-weight: 700;
    color: white;
    font-family: "Montserrat", sans-serif;
    margin-top: 40px;
  }
  .titleCenter {text-align:center; margin-top: 110px;}
  .display-price-wrapper {margin: 30px 0 10px 0; font-size: 30px; display: block;}

  @media screen and (max-width: 1023px) {
    .custom-hero-heading .logoImage {width: 150px;}

    .custom-hero-heading {
      top: 25%;
    }
    .custom-hero-heading h1 {
      font-size: 30px !important;
      margin-bottom: 20px;
    }

    .custom-hero-container {
      background-image: url("/assets/Helsinki-heromobiili.jpg");
    }
    .map-hero-container {
      background-image: url("/assets/Helsinki-mobile.jpg");
      background-position: bottom center;
    }
    .big-desktop-image {
      display: none;
    }
    .portrait-mobile-image {
      display: block;
    }
    .contact-item {
      width: 100% !important;
    }
  }
`;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="video-container-wrapper">
        {/* <div class="top-banner-static-image">
          <div class="custom-hero-heading">
            <h1>Tilaa uudistunut<br />Dei Plus</h1>
            <img class="logoImage" src="/icons/radio_dei_plus.svg" width="100" height="100" />
          </div>
          <img src="/assets/Tilaus-hero.jpeg" class="big-desktop-image" />
          <img src="/assets/tilaa-mobile-hero.jpeg" class="portrait-mobile-image" />
        </div>
        <div class="titleCenter"><h2 class="notFoundTitle">Dei Plus - siellä missä sinäkin</h2></div>
        </div> */}
        <div class="titleCenter"><h2 class="notFoundTitle">{title}</h2></div>
        {hasActiveSubscription && (
          <div styleName="active-subscription-msg">
            Sinulla on jo voimassa oleva tilaus. Voit tarkastella tilaustasi <a href="/profile">Oma profiili</a> -sivulla.
          </div>
        )}
        <div styleName="plans-static-text">
          <p style={{ maxWidth: "1200px", margin: "0 auto 15px" }}>{description}</p>
        </div>
        <div styleName="pricing-container">
          {subscriptionsData.map((group, id) => {
            return (
              <div key={id} styleName="pricing-card">
                <div styleName="pricing-header">{group.name}</div>
                <div styleName="pricing-price">
                  {group?.subscription_plans?.length > 1 ? (
                    <select
                      style={{ opacity: "0", position: "absolute" }}
                      styleName="select-option"
                      onChange={(e) =>
                        setSelectedSubscriptions({
                          ...selectedSubscriptions,
                          [group.name]: JSON.parse(e.target.value),
                        })
                      }
                    >
                      {group.subscription_plans.map((plan, id) => (
                        <option key={id} value={JSON.stringify(plan)}>
                          {plan.title}
                        </option>
                      ))}
                    </select>
                  ) : (
                    group.subscription_plans.map((plan, id) => (
                      <span key={id} className="display-price-wrapper">
                        {plan.title}
                      </span>
                    ))
                  )}
                </div>

                <div styleName="pricing-features">{group.description}</div>

                <div styleName="pricing-button-wrapper">
                  <button
                    styleName={`pricing-button ${hasActiveSubscription ? "disabled" : ""}`}
                    onClick={() => !hasActiveSubscription && handlePlanSelection(group.name)}
                    disabled={hasActiveSubscription}
                  >
                    Tilaa Dei Plus
                  </button>
                </div>
                <div styleName="bottom-red-border"></div>
              </div>
            );
          })}
        </div>
        <div styleName="plans-static-text">
          <p style={{ marginBottom: "0" }}>{footerText}</p>
        </div>
      </div>
    </>
  );
};

GroupsAndPlansModal.propTypes = {
  member: object,
  setActiveTab: func,
  initAccessType: func,
  subscriptionsData: object,
  setSelectedPlan: func,
  getSubscription: func,
};
